// Sidebar section open/closed state, kept for the browser session and reset on every login.
const PREFIX = "cts_nav_open_";
export const COLLAPSED_BY_DEFAULT = ["hours", "admin", "system"];

export const readNavOpen = (id) => {
  const v = sessionStorage.getItem(PREFIX + id);
  return v === null ? !COLLAPSED_BY_DEFAULT.includes(id) : v === "1";
};
export const saveNavOpen = (id, open) => sessionStorage.setItem(PREFIX + id, open ? "1" : "0");
export const resetNavState = () =>
  Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => sessionStorage.removeItem(k));
